$(document).ready(function () {
    let facebookBtn = $('.wc-social-login');
    let pageLink = (window.location.href);
    if (pageLink.indexOf('logowanie') >= 0 || pageLink.indexOf('rejestracja') >= 0 ) {
        console.log('login lub rejestr');
        $(facebookBtn).addClass('facebookRegisterBtn');
    }
});


// WEBPACK FOOTER //
// ./assets/js/register.js